import Image from 'next/image'

const Payments = ({ t }) => {
  return (
    <>
      <h3 className='font-light text-[30px] md:text-[28px] my-6'>{t('payments.title')}</h3>
      <p className='font-normal mb-6'>{t('payments.change-payment-method')}</p>
      <p className='font-light mb-6'>
        {t.rich('payments.change-payment-method-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>

      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image106.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>{t('payments.download-an-invoice')}</p>
      <p className='font-light mb-6'>
        {t.rich('payments.download-an-invoice-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image108.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>{t('payments.choose-your-currency')}</p>
      <p className='font-light mb-1'>
        {t.rich('payments.choose-your-currency-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <p className='font-light mb-6'>
        {t.rich('payments.multi-currency', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image110.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light'>
        {t.rich('payments.single-currency', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image112.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
    </>
  )
}

export default Payments
